// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mr-top{

    margin-top: 40px;
    margin-bottom:40px;
}

.mr-left{
    margin-left: 20px;
}

.example {
    margin: 20px 0;
    margin-bottom: 20px;
    padding: 30px 50px;
    text-align: center;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }


  .site-card-border-less-wrapper {
    padding: 30px;
    background: #ececec;
  }

  input,select,button,textarea,a {
  border-radius: 0;
  -webkit-appearance: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/account/account.css"],"names":[],"mappings":"AAAA;;IAEI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;EACpB;;;EAGA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;EACA,gBAAgB;EAChB,wBAAwB;AAC1B","sourcesContent":[".mr-top{\n\n    margin-top: 40px;\n    margin-bottom:40px;\n}\n\n.mr-left{\n    margin-left: 20px;\n}\n\n.example {\n    margin: 20px 0;\n    margin-bottom: 20px;\n    padding: 30px 50px;\n    text-align: center;\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 4px;\n  }\n\n\n  .site-card-border-less-wrapper {\n    padding: 30px;\n    background: #ececec;\n  }\n\n  input,select,button,textarea,a {\n  border-radius: 0;\n  -webkit-appearance: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
